import { useQuery } from "@tanstack/react-query";
import { Alert } from "../../types";
import { alertService } from "../../services/alertsService";

export const useAlert = (id: string | undefined) => {
  return useQuery<Alert>({
    queryKey: ["alert", id],
    enabled: !!id,
    queryFn: async () => {
      const r = await alertService.get(id!);
      if(!r) {
        throw new Error(`Error retriving alert ${id}`);
      }
      return r;
    },
  });
};

